import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SectionFileDatasourceService } from 'file-datasource-service-lib';
import { ISection } from 'interfaces-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SectionComponentBase } from '../section-component-base';

@Component({
    selector: 'app-docx-template-section',
    templateUrl: './docx-template-section.component.html',
    styleUrls: ['./docx-template-section.component.scss'],
    standalone: false
})
export class DocxTemplateSectionComponent extends SectionComponentBase implements OnDestroy {
  @Input() formGroup: UntypedFormGroup;
  @Input() workflowConfigId: string;
  @Input() templateValid = false;

  @Output() docxFileNameChange = new EventEmitter<string>();

  constructor(private sectionService: SectionFileDatasourceService) {
    super();
  }

  public static override buildForm(formGroup: UntypedFormGroup, section?: ISection): void {
    formGroup.get('sourceType').setValue('S3');
    formGroup.addControl('file', new UntypedFormControl());
    formGroup.get('referenceId').setValue(section?.referenceId ?? 'DOCX_TEMPLATE_1');

    formGroup.get('required').setValue(formGroup.get('sourceValue').value !== null);
    formGroup.get('sourceValue').valueChanges.subscribe((filename) => formGroup.get('required').setValue(filename !== null));
  }

  getInfo(): Observable<string> {
    const file = this.formGroup.get('file').value;
    const request = file ?? {
      workflowConfigId: this.workflowConfigId,
      sectionId: this.formGroup.get('id').value,
      fileName: this.formGroup.get('sourceValue').value,
    };

    return this.sectionService.getSectionFileInfo(request).pipe(
      map((info) => {
        return this.buildTemplateInfo(info);
      })
    );
  }

  ngOnDestroy(): void {
    console.log('Destroying DocxTemplateSectionComponent');
  }

  private buildTemplateInfo(info: any): string {
    if (info.error) {
      return `<p>${info.error}</p>`;
    }

    const addInInfo = JSON.parse(info.addInInfo);
    const namespaces = JSON.parse(info.namespaces);
    let data = `<p>Built with version <b>${addInInfo.currentVersion}</b> of the Word AddIn.</p>`;
    if (namespaces.error) {
      data = data + `<p>${namespaces.error}</p>`;
    } else {
      if (namespaces.length === 1) {
        data = data + `<p>Designed for <b>${namespaces[0].entities[0]}</b> entities.</p>`;
      } else {
        const namespaceNames = namespaces.map((ns) => ns.namespace).join(', ');
        data = data + `<p>Multiple namespaces: ${namespaceNames}</p`;
      }
    }

    return data;
  }

  onDocxFileNameChange(fileName: string): void {
    this.docxFileNameChange.emit(fileName);
  }
}
